import log from '@/utils/consolelog'
import plan from '@/api/modules/plan'
import * as mutations from './mutations'

const initialState = {
	data: null,
	loading: false,
	error: null
}

export default {
	state: Object.assign({}, initialState),
	getters: {
		isFree: state => state.data ? state.data.note === 'Free Plan' : null,
		isPro: state => state.data ? state.data.note === 'PRO Plan' : null,
		getMaxSeats: state => state.data ? state.data.seats : null,
		getMaxWatches: state => state.data ? state.data.watches : null
	},
	mutations: {
		[mutations.SET_PLAN] (state, value) {
			state.data = value
		},
		[mutations.SET_PLAN_LOADING] (state, value) {
			state.loading = value
		},
		[mutations.SET_PLAN_ERROR] (state, value) {
			state.error = value
		},
		[mutations.CLEAR_PLAN] (state) {
			Object.assign(state, initialState)
		}
	},
	actions: {
		getPlan ({ commit, state }, { context, user_uid }) {
			if (!state.loading) {
				commit(mutations.SET_PLAN_LOADING, true)
				plan.getPlan(context, user_uid).then(response => {
					log.log('store', 'plan.getPlan OK', response)()
					const plan = response.body
					commit(mutations.SET_PLAN, plan)
				}).catch(error => {
					log.error('store', 'plan.getPlan ERROR', error)()
					commit(mutations.SET_PLAN_ERROR, error)
				}).finally(() => {
					commit(mutations.SET_PLAN_LOADING, false)
				})
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/plan.js